export default {
    close(state) {
        state.show = false;
    },
    show(state, param = {}) {
        let confirmCallback = param.confirmCallback;
        if(!confirmCallback) {
            confirmCallback = () => {};
        }
        let clearCallback = param.clearCallback;
        if(!clearCallback) {
            clearCallback = () => {};
        }
        Object.assign(state, param, {
            show: true,
            confirmCallback,
            clearCallback,
        });
    },
};



// WEBPACK FOOTER //
// ./src/ui/confirm/store/mutations.js